import React, { useState } from "react";
import { formatMonthYearLong, getTodayMonthYearBrazil } from "../../../utils/dateUtils";
import { AdminPageHeader } from "../shared";
import { Icons } from "../../shared/Icons";
import { MonthlyBalance } from "./MonthlyBalance";
import { MonthlyRevenueTargetProgress } from "./MonthlyRevenueTargetProgress";
import { ReportsProfessionalSelect } from "./ReportsProfessionalSelect";
import { useAdminReportsProfessional } from "./useAdminReportsProfessional";
import { MonthlyProfit } from "../AdminExpenses/MonthlyProfit";

export const AdminCaixaDoMesPage: React.FC = () => {
  const [monthYear, setMonthYear] = useState(() => getTodayMonthYearBrazil());
  const { month, year } = monthYear;
  const {
    professionalIdForDailyBalance,
    showProfessionalSelector,
    professionals,
    selectedProfessionalId,
    setSelectedProfessionalId,
    loadingProfessionals,
  } = useAdminReportsProfessional();

  const handleMonthYearChange = (nextMonth: number, nextYear: number) => {
    setMonthYear({ month: nextMonth, year: nextYear });
  };

  return (
    <div className="space-y-4 sm:space-y-6 md:space-y-8 animate-fade-in">
      <AdminPageHeader
        icon={<Icons.CalendarMonth sx={{ fontSize: 28 }} />}
        title="Caixa do Mês"
        subtitle={`${formatMonthYearLong(month, year)} • Saldo e movimentação mensal`}
        rightContent={
          showProfessionalSelector ? (
            <ReportsProfessionalSelect
              professionals={professionals}
              selectedProfessionalId={selectedProfessionalId}
              onSelectProfessional={setSelectedProfessionalId}
              loading={loadingProfessionals}
            />
          ) : undefined
        }
      />

      <div className="grid grid-cols-1 gap-4 sm:gap-6 md:gap-8">
        <MonthlyBalance
          professionalId={professionalIdForDailyBalance}
          month={month}
          year={year}
          onMonthYearChange={handleMonthYearChange}
        />
        <MonthlyRevenueTargetProgress month={month} year={year} />
        <MonthlyProfit
          month={month}
          year={year}
          onMonthYearChange={handleMonthYearChange}
        />
      </div>
    </div>
  );
};
